<lib-modal
  [title]="'Masshantera stödgrund'"
  [showCloseButton]="true"
  [showSecondaryButton]="true"
  [showPrimaryButton]="false"
  [secondaryButtonText]="'Uppdatera'"
  (secondaryButton)="updateStodgrund()"
  (closeModal)="modalService.hide()"
  ><p>
    Här kan du masshantera val av stödgrund för flera eller alla
    bidragsmottagare
  </p>
  <div class="d-flex justify-content-end mb-4">
    <lib-vinnova-checkboxes
      [singleCheckbox]="true"
      [checkboxObjects]="[
        {
          id: '0',
          label: 'Markera/avmarkera alla',
        },
      ]"
      [(ngModel)]="allWorksitesSelected"
      (ngModelChange)="toggleSelectAll($event)"
      [error]="validated() && !anyWorksiteSelected"
    >
    </lib-vinnova-checkboxes>
  </div>
  <ul>
    @for (worksite of worksites; track $index) {
      <li>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <div class="heading-size-5">{{ worksite.company.name }}</div>
            <div class="worksite-information">
              Organisationsnummer:
              {{
                worksite.company.nationalRegistrationNumber ??
                  worksite.company.vat
              }}
            </div>
            <div class="worksite-information">Stödgrund:</div>
          </div>
          <div>
            <lib-vinnova-checkboxes
              [singleCheckbox]="true"
              [checkboxObjects]="[
                {
                  id: worksite.id,
                  label: 'Välj',
                },
              ]"
              [(ngModel)]="selectedWorksites[worksite.id]"
              (ngModelChange)="selectedWorksiteChange()"
              [error]="validated() && !anyWorksiteSelected"
            >
            </lib-vinnova-checkboxes>
          </div>
        </div>
      </li>
    }
  </ul>

  <div class="row">
    <div class="col-6">
      <lib-input-container
        [label]="'Stödgrund'"
        required="true"
        [for]="'stodgrund'"
      >
        <lib-vinnova-dropdown
          [id]="'stodgrund'"
          [items]="stodgrunderItems"
          required="true"
          [(ngModel)]="stodgrund"
          [error]="validated() && !stodgrund"
        >
        </lib-vinnova-dropdown>
      </lib-input-container>
    </div>
    @if (sfsStodgrunderItems[stodgrund]?.length > 0) {
      <div class="col-6">
        <lib-input-container
          [label]="'Vinnovas förordning SFS 2015:208'"
          required="true"
          [for]="'sfs-stodgrund'"
        >
          <lib-vinnova-dropdown
            [id]="'sfs-stodgrund'"
            [items]="sfsStodgrunderItems[stodgrund]"
            required="true"
            [(ngModel)]="sfsStodgrund"
            [error]="validated() && !sfsStodgrund"
          >
          </lib-vinnova-dropdown>
        </lib-input-container>
      </div>
    }
  </div>

  @if (validated() && hasValidationError) {
    <div class="row">
      <div class="col">
        <div class="invalid-feedback">
          <lib-icon name="alert-circle" size="x-small"></lib-icon> Fyll i värden
          för att uppdatera stödgrund
        </div>
      </div>
    </div>
  }
</lib-modal>
